import React from "react";
import {connect} from "react-redux";
import Col from "@prism/col";
import Row from "@prism/row";
import "../../../styles/review-panel.css";
import useCustomImagesConfig from "../../../hooks/useCustomImagesConfig";

const ClientPhotosInfoReview = (props) => {
    const { clientPhotosSettings } = useCustomImagesConfig(
        props.account,
        props.designatedDescriptionResponse
    );

    if (clientPhotosSettings) {
        const { captionedPhotoDescription, captionedPhotoItems, additionalPhotosDescription } = clientPhotosSettings;

        return (
            <Row className={`px-6 py-4 mx-0 review-row`}>
                <Col className="flex-grow-1">
                    <Row className="h2 review-row-title"><Col>Client Photos</Col></Row>
                    <div className="client-photos-info-review">
                        <ul className="client-photos-review-bullets">
                            {captionedPhotoDescription && (
                                <li className="font-weight-bold">
                                    {captionedPhotoDescription}
                                    {captionedPhotoItems.length > 0 && (
                                        <ul className="client-photos-sub-bullets">
                                            {captionedPhotoItems.map((item, index) => (
                                                <li className="font-weight-lighter" key={index}>{item}</li>
                                            ))}
                                        </ul>
                                    )}
                                </li>
                            )}
                            {additionalPhotosDescription.length > 0 &&
                                additionalPhotosDescription.map((photo, index) => (
                                    <li className="font-weight-bold" key={index}>{photo}</li>
                                ))}
                        </ul>
                    </div>
                </Col>
                <Col className="flex-grow-0">
                    <i className="icon prism-icon-info" style={{color: "#005ba8"}}/>
                </Col>
            </Row>
        );
    }

    return null;
};

function mapStateToProps({designatedDescriptionResponse, account}) {
    return {designatedDescriptionResponse, account};
}

export default connect(mapStateToProps)(ClientPhotosInfoReview);